export default __webpack_public_path__ + "static/media/Ripple.e9420ade.png";